import type UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';

export default class ErrorAgeUnderThirteenSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-error-age-under-thirteen';

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public predicate(): boolean {
    const { isUnderThirteen } = this.sessionInfo.value;
    if (!isUnderThirteen) {
      return false;
    }
    return true;
  }

  public async toNextScreen(): Promise<boolean> {
    this.sessionInfo.value.completedDetailsScreens.push(this.screenName);
    return true;
  }

  public getProgress(): number {
    const container = document.querySelector('.hekate-progress-bar') as HTMLDivElement;
    const progressBar = container.querySelector('.progress-bar') as HTMLDivElement;
    progressBar.classList.remove('bg-success');
    progressBar.classList.add('bg-danger');
    return 100;
  }
}
